exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-switcher[data-v-520adb3a]{display:flex;flex-direction:column;flex-grow:1;overflow:hidden}.tab-switcher .tabs[data-v-520adb3a]{height:100%;overflow:hidden}.tab-switcher .tabs .tab[data-v-520adb3a]{display:flex;flex-direction:column;height:100%;overflow:auto;background:#fefefe}", ""]);

// exports
